module.exports = __webpack_public_path__ + "assets/img/title-af333b14.png";